import type { SVGProps } from "react";
import * as React from "react";

const SvgAlertTriangle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="m10.29 2.86-.855-.519-.003.005zM1.82 17l-.858-.514-.008.014zm1.71 3-.011 1h.01zm16.94 0v1h.01zm1.71-3 .866-.5-.008-.014zM13.71 2.86l.858-.514-.003-.005zM12 1.897v-1zM13 8a1 1 0 1 0-2 0zm-2 4a1 1 0 0 0 2 0zm1 3a1 1 0 1 0 0 2zm.01 2a1 1 0 0 0 0-2zM9.432 2.346l-8.47 14.14 1.716 1.028 8.47-14.14zM.954 16.5a3 3 0 0 0-.402 1.492l2 .005a1 1 0 0 1 .134-.497zm-.402 1.492a3 3 0 0 0 .393 1.494l1.738-.99a1 1 0 0 1-.131-.499zm.393 1.494a3 3 0 0 0 1.085 1.1l1.015-1.724a1 1 0 0 1-.362-.367zm1.085 1.1c.452.265.965.408 1.489.414l.022-2a1 1 0 0 1-.496-.138zm1.5.414h16.94v-2H3.53zm16.95 0a3 3 0 0 0 1.49-.414l-1.015-1.724a1 1 0 0 1-.496.138zm1.49-.414a3 3 0 0 0 1.084-1.1l-1.737-.99a1 1 0 0 1-.362.366zm1.084-1.1a3 3 0 0 0 .394-1.494l-2 .005a1 1 0 0 1-.131.498zm.394-1.494a3 3 0 0 0-.402-1.492l-1.732 1a1 1 0 0 1 .134.497zm-.41-1.506-8.47-14.14-1.716 1.028 8.47 14.14zM14.565 2.341a3 3 0 0 0-1.093-1.058l-.982 1.743c.15.084.276.206.365.353zm-1.093-1.058A3 3 0 0 0 12 .897v2a1 1 0 0 1 .49.129zM12 .897a3 3 0 0 0-1.472.386l.981 1.743a1 1 0 0 1 .49-.129zm-1.472.386a3 3 0 0 0-1.093 1.058l1.71 1.038a1 1 0 0 1 .364-.353zM11 8v4h2V8zm1 9h.01v-2H12z"
    />
  </svg>
);
export default SvgAlertTriangle;
